export default "{\n    \"label\": \"Categories of Service\",\n    \"placeholderText\": \"Select Categories\"\n}\n"